import axios from 'axios';
import {API_NAMESPACE, API_NONCE, API_ROOT_URL} from '@/const';

const AxiosService = axios.create();

AxiosService.defaults.baseURL = `${API_ROOT_URL}${API_NAMESPACE}/v1`;
AxiosService.defaults.headers.common['X-WP-Nonce'] = API_NONCE;
AxiosService.defaults.timeout = 120000;

export default AxiosService;
